/**
 * @author      patrick@zumper.com (Patrick Giddings)
 * @copyright   Copyright (c) 2022, Zumper
 */

import type { Listable, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import cookies from 'browser-cookies'
import { logger } from '../../logger'

export const LISTING_COOKIE_BASE = 'pa_detail_click_'
export const LISTING_COOKIE_TTL_DAYS = 5 / 86400 // 5s
export const LISTING_DETAIL_URL_REGEX = /\/address\/([^/#?]+)(?:\?[^#]*)?(?:#(.*))?/

export const setListingDetailCookie = (
  url: string | undefined | null,
  entity?: Partial<Listable | Property> | Pin<RawPinInventorySearch> | null
) => {
  try {
    const match = url?.match(LISTING_DETAIL_URL_REGEX)
    const uId = match?.[2] ?? entity?.uId
    if (match && uId) {
      // ZUM-56276: set detail cookie to preserve specific listing id user is interested in
      cookies.set(`${LISTING_COOKIE_BASE}${match[1]}`, uId, {
        expires: LISTING_COOKIE_TTL_DAYS,
      })
    }
  } catch (e) {
    logger.info('Error setting listing detail cookie', url, entity, e)
  }
}
